import { render, staticRenderFns } from "./editnewUserPromo.vue?vue&type=template&id=b90dce1a&"
import script from "./editnewUserPromo.vue?vue&type=script&lang=js&"
export * from "./editnewUserPromo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports